module.exports = __webpack_public_path__ + "static/media/card-preview.641b4e82.jpg";